<div class="col home-page-container">
	<pk-broker-loader [show]="loading"></pk-broker-loader>
	<pk-broker-page-warnings [warnings]="warnings"></pk-broker-page-warnings>
	<ng-container *ngIf="!loading && loggedInUser && agentTree && agentTree.length">
		<div class="row mb-4" *ngFor="let agent of agentTree">
			<div class="col-md-12">
				<section class="clearfix">
					<div class="card add-box-styles">
						<div class="card-body">
							<h4 class="card-title d-inline-block">{{ agent.displayName }}</h4>
							<div class="toolbar-buttons float-right">
								<a
									*ngIf="
										loggedInUser.agentId === agent.agentId ||
										!loggedInUser.agentId ||
										!loggedInUser.agent?.parentId ||
										loggedInUser.agent?.isInHouseIndirectSale
									"
									[routerLink]="[environment.cPanel.agent.edit, agent.agentId]"
									class="btn btn-link py-0 px-2"
									container="body"
									tooltip="Click to edit agent">
									<fa-icon [icon]="['fas', 'pencil']"></fa-icon> Edit
								</a>
							</div>
							<div class="row mt-3">
								<div class="col-12">
									<div class="row">
										<div class="col-12 col-md-6 col-xl-3 mb-md-3">
											<p class="font-size-085 mb-0">Name</p>
											<p class="font-size-095 semibold-text">{{ agent.displayName }}</p>
										</div>
										<div class="col-12 col-md-6 col-xl-3 mb-md-3">
											<p class="font-size-085 mb-0">Contact</p>
											<p class="font-size-095 semibold-text">{{ agent.getContactFullName() }}</p>
										</div>
										<div class="col-12 col-md-6 col-xl-3 mb-md-3">
											<p class="font-size-085 mb-0">Email</p>
											<p class="font-size-095 semibold-text">
												<ng-container *ngIf="agent.email">
													<a [href]="'mailto:' + agent.email">{{ agent.email }}</a>
												</ng-container>
												<ng-container *ngIf="!agent.email">N/A</ng-container>
											</p>
										</div>
										<div class="col-12 col-md-6 col-xl-3 mb-md-3">
											<p class="font-size-085 mb-0">Phone</p>
											<p class="font-size-095 semibold-text">
												<ng-container *ngIf="agent.phone">
													<a [href]="'tel:' + agent.phone">{{ agent.phone | phone: agent.phoneCountryId }}</a
													><span *ngIf="agent.ext">ext. {{ agent.phoneExt }}</span>
												</ng-container>
												<ng-container *ngIf="!agent.phone">N/A</ng-container>
											</p>
										</div>
										<div class="col-12 col-md-6 col-xl-3 mb-md-3">
											<p class="font-size-085 mb-0">Mobile</p>
											<p class="font-size-095 semibold-text">
												<ng-container *ngIf="agent.mobile">
													<a [href]="'tel:' + agent.mobile">{{ agent.mobile | phone: agent.phoneCountryId }}</a>
												</ng-container>
												<ng-container *ngIf="!agent.mobile">N/A</ng-container>
											</p>
										</div>
										<ng-container *ngIf="!agent.isSaas">
											<div class="col-12 col-md-6 col-xl-3 mb-md-3">
												<p class="font-size-085 mb-0">License Plan</p>
												<p class="font-size-095 semibold-text">{{ agent.getAgentLicensePlan()?.licensePlan?.name || 'N/A' }}</p>
											</div>
											<div class="col-12 col-md-6 col-xl-3 mb-md-3">
												<p class="font-size-085 mb-0">Add-Ons</p>
												<p class="font-size-095 semibold-text">
													<ng-container *ngFor="let addOn of agent.getAddOns()"> {{ addOn.name }}<br /> </ng-container>
													<ng-container *ngIf="!agent.getAddOns()?.length">N/A</ng-container>
												</p>
											</div>
											<ng-container *ngIf="!agent.parentId">
												<div class="col-12 col-md-6 col-xl-3 mb-md-3">
													<p class="font-size-085 mb-0">Failed Payment</p>
													<p class="font-size-095 semibold-text">{{ agent.hasFailedPayment ? 'Yes' : 'No' }}</p>
												</div>
											</ng-container>
											<ng-container *ngIf="isAdmin && agent.agentStripeCustomer?.stripeCustomerId">
												<div class="col-12 col-md-6 col-xl-3 mb-md-3">
													<p class="font-size-085 mb-0">Stripe Customer</p>
													<p class="font-size-095 semibold-text">
														<a target="_blank" [href]="stripeCustomerDashboard + agent.agentStripeCustomer.stripeCustomerId"
															>Go To Stripe <fa-icon [icon]="['fas', 'up-right-from-square']"></fa-icon
														></a>
													</p>
												</div>
											</ng-container>
										</ng-container>
									</div>
								</div>
							</div>
							<ng-container *ngIf="!agent.parentId && !agent.isSaas">
								<hr />
								<div class="row">
									<ng-container *ngFor="let tagCategory of tagCategories">
										<div class="col-12 col-md-6 col-xl-3 mb-md-3">
											<p class="font-size-085 mb-0">{{ tagCategory.name }}</p>
											<p class="font-size-095 semibold-text" *ngIf="!agent.tagsByCategory[tagCategory.id]?.length">Unknown</p>
											<p class="font-size-095 semibold-text" *ngIf="agent.tagsByCategory[tagCategory.id]?.length === 1">
												{{ agent.tagsByCategory[tagCategory.id][0].name }}
											</p>
											<ul *ngIf="agent.tagsByCategory[tagCategory.id]?.length > 1">
												<li class="font-size-095 semibold-text" *ngFor="let tag of agent.tagsByCategory[tagCategory.id]">{{ tag.name }}</li>
											</ul>
										</div>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
				</section>
			</div>
		</div>
		<div class="row mb-4">
			<div class="col-md-12">
				<section class="clearfix">
					<div class="card add-box-styles">
						<div class="card-body">
							<h4 class="card-title d-inline-block">Logins</h4>
							<div class="toolbar-buttons float-right">
								<a
									*ngIf="loggedInUser.isAdmin || loggedInUser.isOwner || (!agent.isSaas && loggedInUser.isRole('sales manager'))"
									[routerLink]="[
										environment.cPanel.users.add,
										agent.parentId && (!agent.isSaas || agent.brotherId) ? 'sales' : 'sales manager',
										agent.agentId,
									]"
									class="btn btn-link py-0 px-2"
									container="body"
									tooltip="Click to add a login">
									<fa-icon [icon]="['fas', 'plus']"></fa-icon> Add
								</a>
							</div>
							<div class="table-responsive">
								<table class="table table-sm table-bordered table-striped table-hover">
									<thead>
										<tr>
											<th>Username</th>
											<th>Last Login</th>
											<th>Add Date</th>
											<th>Active</th>
											<th>Primary</th>
											<th>Locked</th>
											<th>Password Expired</th>
											<th class="text-center"><span *ngIf="loggedInUser.hasPermission('user-admin')">Actions</span></th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let login of agent.logins | filter: 'agentId' : agent.agentId">
											<td>{{ login.username }}</td>
											<td>
												<span [ngClass]="{ 'label label-warning': login.getDisplayLastLogin() === 'Never' }">
													{{ login.getDisplayLastLogin() }}
												</span>
											</td>
											<td>{{ login.addDate | date: environment.dateFormat }}</td>
											<td><fa-icon [icon]="['fas', 'check']" *ngIf="login.isActive"></fa-icon></td>
											<td><fa-icon [icon]="['fas', 'check']" *ngIf="login.isPrimary"></fa-icon></td>
											<td><fa-icon [icon]="['fas', 'check']" *ngIf="login.isLocked"></fa-icon></td>
											<td><fa-icon [icon]="['fas', 'check']" *ngIf="login.isPasswordExpired"></fa-icon></td>
											<td>
												<a
													[routerLink]="[
														environment.cPanel.users.edit,
														agent.parentId && (!agent.isSaas || agent.brotherId) ? 'sales' : 'sales manager',
														agentTree[0].agentId,
														login.userId,
													]"
													class="btn btn-link py-0 px-2"
													container="body"
													tooltip="Click to edit"
													[adaptivePosition]="false">
													<fa-icon [icon]="['fas', 'edit']"></fa-icon>
												</a>
												<a
													*ngIf="loggedInUser.isAdmin && !login.impersonationLoading"
													href="javascript:void(0)"
													(click)="impersonateUser(login)"
													class="btn btn-link py-0 px-2"
													container="body"
													tooltip="Click to impersonate user"
													[adaptivePosition]="false"
													><fa-icon [icon]="['fas', 'user-secret']"> </fa-icon>
												</a>
												<a *ngIf="login.impersonationLoading"><fa-icon [icon]="['fas', 'spinner']" animation="spin" size="lg"></fa-icon></a>
												<a
													*ngIf="loggedInUser.isAdmin && !login.sendingWelcomeEmail"
													href="javascript:void(0)"
													(click)="sendWelcomeEmail(login)"
													class="btn btn-link py-0 px-2"
													container="body"
													tooltip="Click to send the welcome email"
													[adaptivePosition]="false">
													<fa-icon [icon]="['fas', 'paper-plane']"></fa-icon>
												</a>
												<a *ngIf="login.sendingWelcomeEmail"><fa-icon [icon]="['fas', 'spinner']" animation="spin" size="lg"></fa-icon></a>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</ng-container>
</div>
